<div class="progress-card progress-card--primary">
  <div class="progress-card__content">
    <div class="progress-card__percentage-text">{{ (completionRate()) / 100 | percent }}</div>
    <div class="progress-card__body">
      <div class="progress-card__header">
        <div class="progress-card__title">{{ 'app.components.progressCard.title' | translate }}</div>
        <div class="badge badge--success">{{ badgeTextKey() | translate }}</div>
      </div>
      <div class="progress-card__description">
        {{ 'app.components.progressCard.description' | translate }}
      </div>
    </div>
  </div>
</div>


